const table = [
    {
        prop: 'Region',
        label: 'Región',
        minWidth: 100
    },
    {
        prop: 'Depart_Code',
        label: 'Cod. Dpto.',
        minWidth: 100
    },
    {
        prop: 'Depart_Nombre',
        label: 'Departamento',
        minWidth: 150
    },
    {
        prop: 'Municipio_Code',
        label: 'Cod. Munic.',
        minWidth: 100
    },
    {
        prop: 'Municipio',
        label: 'Municipio',
        minWidth: 100
    },
    {
        prop: 'IDPuntoAnt',
        label: 'ID Punto Anterior',
        minWidth: 150
    },
    {
        prop: 'Coordenadas',
        label: 'Coordenadas',
        minWidth: 150
    },
    {
        prop: 'Nombres',
        label: 'Cliente',
        minWidth: 150
    }
]

const table_plus = [
    {
        prop: "Ejecutor",
        label: "Ejecutor", 
    },
    {
        prop: "clienteAccesoAnt",
        label: "clienteAccesoAnt", 
    },
    {
        prop: "IDPuntoAnt",
        label: "IDPuntoAnt", 
    },
    {
        prop: "EstadoActualAnt",
        label: "EstadoActualAnt", 
    },
    {
        prop: "RegionAnt",
        label: "RegionAnt", 
    },
    {
        prop: "Depart_CodeAnt",
        label: "Depart_CodeAnt", 
    },
    {
        prop: "Depart_NombreAnt",
        label: "Depart_NombreAnt", 
    },
    {
        prop: "Municipio_CodeAnt",
        label: "Municipio_CodeAnt", 
    },
    {
        prop: "MunicipioAnt",
        label: "MunicipioAnt", 
    },
    {
        prop: "BarrioAnt",
        label: "BarrioAnt", 
    },
    {
        prop: "DireccionAnt",
        label: "DireccionAnt", 
    },
    {
        prop: "EstratoAnt",
        label: "EstratoAnt", 
    },
    {
        prop: "CoordenadasAnt",
        label: "CoordenadasAnt", 
    },
    {
        prop: "NombresAnt",
        label: "NombresAnt", 
    },
    {
        prop: "TelefonoAnt",
        label: "TelefonoAnt", 
    },
    {
        prop: "CelularAnt",
        label: "CelularAnt", 
    },
    {
        prop: "CorreoEAnt",
        label: "CorreoEAnt", 
    },
    {
        prop: "VIPAnt",
        label: "VIPAnt", 
    },
    {   
        prop: "ProyectoCodeVIPAnt",
        label: "ProyectoCodeVIPAnt", 
    },
    {
        prop: "ProyectoNombreVIPAnt",
        label: "ProyectoNombreVIPAnt", 
    },
    {
        prop: "VelocidadContratadaAnt",
        label: "VelocidadContratadaAnt", 
    },
    {
        prop: "MetaAnt",
        label: "MetaAnt", 
    },
    {
        prop: "SolUM",
        label: "SolUM", 
    },
    {
        prop: "OperadorPrestante",
        label: "OperadorPrestante", 
    },
    {
        prop: "IPAnt",
        label: "IPAnt", 
    },
    {
        prop: "OLTAnt",
        label: "OLTAnt", 
    },
    {
        prop: "PuertoOLTAnt",
        label: "PuertoOLTAnt", 
    },
    {
        prop: "MacAnt",
        label: "MacAnt", 
    },
    {
        prop: "PortONUAnt",
        label: "PortONUAnt", 
    },
    {
        prop: "NodoAnt",
        label: "NodoAnt", 
    },
    {
        prop: "ArmarioAnt",
        label: "ArmarioAnt", 
    },
    {
        prop: "RedPrimariaAnt",
        label: "RedPrimariaAnt", 
    },
    {
        prop: "RedSecundariaAnt",
        label: "RedSecundariaAnt", 
    },
    {
        prop: "NdoAnt",
        label: "NdoAnt", 
    },
    {
        prop: "AmplificadorAnt",
        label: "AmplificadorAnt", 
    },
    {
        prop: "TapBocaAnt",
        label: "TapBocaAnt", 
    },
    {
        prop: "MacCpeAnt",
        label: "MacCpeAnt", 
    },
    {
        prop: "DocClienteAcceso",
        label: "DocClienteAcceso", 
    },
    {
        prop: "Region",
        label: "Region", 
    },
    {
        prop: "Depart_Code",
        label: "Depart_Code", 
    },
    {
        prop: "Depart_Nombre",
        label: "Depart_Nombre", 
    },
    {
        prop: "Municipio_Code",
        label: "Municipio_Code", 
    },
    {
        prop: "Municipio",
        label: "Municipio", 
    },
    {
        prop: "Barrio",
        label: "Barrio", 
    },
    {
        prop: "Direccion",
        label: "Direccion", 
    },
    {
        prop: "Estrato",
        label: "Estrato", 
    },
    {
        prop: "Operador",
        label: "Operador", 
    },
    {
        prop: "Coordenadas",
        label: "Coordenadas", 
    },
    {
        prop: "Nombres",
        label: "Nombres", 
    },
    {
        prop: "Telefono",
        label: "Telefono", 
    },
    {
        prop: "Celular",
        label: "Celular", 
    },
    {
        prop: "CorreoE",
        label: "CorreoE", 
    },
    {
        prop: "VIP",
        label: "VIP", 
    },
    {
        prop: "ProyectoCodeVIP",
        label: "Código VIP", 
    },
    {
        prop: "ProyectoNombreVIP",
        label: "Nombre VIP", 
    },
    {
        prop:"VelocidadContratada",
        label:"VelocidadContratada",
    },
    {
        prop:"Meta",
        label:"Meta",
    },
    {
        prop:"SolUM",
        label:"SolUM",
    },
    {
        prop:"OperadorPrestante",
        label:"OperadorPrestante",
    },
    {
        prop: "IP",
        label: "IP", 
    },
    {
        prop:"OLT",
        label:"OLT",
    },
    {
        prop:"PuertoOLT",
        label:"PuertoOLT",
    },
    {
        prop: "Mac",
        label: "MAC", 
    },
    {
        prop:"PortONU",
        label:"PortONU",
    },
    {
        prop:"Nodo",
        label:"Nodo",
    },
    {
        prop:"Armario",
        label:"Armario",
    },
    {
        prop:"RedPrimaria",
        label:"RedPrimaria",
    },
    {
        prop:"RedSecundaria",
        label:"RedSecundaria",
    },
    {
        prop:"Ndo",
        label:"Ndo",
    },
    {
        prop:"Amplificador",
        label:"Amplificador",
    },
    {
        prop:"TapBoca",
        label:"TapBoca",
    },
    {
        prop:"MacCpe",
        label:"MacCpe",
    },
    {
        prop:"Sisben4",
        label:"Sisben4",
    },
    {
        prop: "Etnia",
        label: "Etnia", 
    },
    {
        prop: "Genero",
        label: "Género", 
    },
    {
        prop: "OrientSexual",
        label: "Orientación Sexual", 
    },
    {
        prop: "Sexo",
        label: "Sexo", 
    },
    {
        prop: "NivelEducativo",
        label: "Nivel Educativo", 
    },
    {
        prop: "Discapacidad",
        label: "Discapacidad", 
    }
]

export default [table, table_plus]
